export default "__VITE_ASSET__BhviU7xR__"